enum actionTypes {
  FETCH_SKI_RENTALS = "FETCH_SKI_RENTALS",
  FETCH_SKI_RENTAL_TYPES = "FETCH_SKI_RENTAL_TYPES",
}

export default actionTypes;
